<template>
	<div class="row mb-3 align-items-center" v-if="project.configuration !== null">
		<div class="col-12 col-md-9">
			<h5>{{ project.configuration.description }}</h5>
		</div>
	</div>
</template>

<script>
//import log from './services/logger/index'

export default {
	computed: {
		project: {
			get() {
				return this.$store.state.projectData.project
			},
			set(value) {
				this.$store.commit('projectData/updateProject', value)
			}
		},
		configuration: {
			get() {
				return this.$store.state.user.configuration
			},
			set(value) {
				this.$store.commit('user/updateConfiguration', value)
			}
		},
	},
    data() {
		return {
			
				
		}
    	
    },
	methods: {
		
	},
    
    watch: {
    	
    },
	mounted() {

	}
  }
</script>